import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios' //追記
import VueAxios from 'vue-axios' //追記
import VueSmoothScroll from 'vue3-smooth-scroll' //追記
import { library } from '@fortawesome/fontawesome-svg-core' //追加
import { fas } from '@fortawesome/free-solid-svg-icons' //追加
import { far } from '@fortawesome/free-regular-svg-icons' //追加
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome' //追加
import * as Sentry from '@sentry/vue'

Vue.config.productionTip = false

require('@/assets/sass/main.scss')

library.add(fas, far)

const upperFirst = require('lodash.upperfirst')
const camelCase = require('camelcase')

Vue.config.productionTip = false

const requirePluginsComponent = require.context(
  '@/components/plugins/',
  true,
  /.vue$/
)

// ./components/plugins/以下をglobal登録する
requirePluginsComponent.keys().forEach(fileName => {
  // コンポーネント設定を取得する
  const componentConfig = requirePluginsComponent(fileName)

  // コンポーネント名をパスカルケース (PascalCase) で取得する
  const componentName = upperFirst(
    camelCase(
      // フォルダの深さに関わらずファイル名を取得する
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // コンポーネントをグローバル登録する
  Vue.component(
    componentName,
    // `export default` を使ってコンポーネントがエクスポートされた場合に存在する
    // `.default` でコンポーネントオプションを期待していて
    // 存在しない場合にはモジュールのルートにフォールバックします。
    componentConfig.default || componentConfig
  )
})

Vue.use(VueSmoothScroll, {
  duration: 400,
  updateHistory: false,
})

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN || '',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
    Sentry.httpClientIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.NODE_ENV,
})

new Vue({
  router,
  store,
  axios,
  VueAxios,
  render: h => h(App),
}).$mount('#app')

Vue.component('font-awesome-icon', FontAwesomeIcon)
